const TR_DAYS = ["Pzt", "Sal", "Çar", "Per", "Cum", "Cmt", "Paz"];

/**
 * Ay değişirken takvimin yerini tutan iskelet. Gerçek ızgarayla aynı ölçüleri
 * kullanıyor ki yeni ay verisi gelince kart zıplamasın.
 */
export default function CalendarSkeleton({ weeks = 5, offset = 0 }) {
  const cells = weeks * 7;
  return (
    <div className="w-full" data-testid="calendar-skeleton" aria-hidden>
      <div className="grid grid-cols-7 gap-2 mb-2">
        {TR_DAYS.map((d) => (
          <div key={d} className="text-[11px] text-terakkiBorder text-center font-SemiBold uppercase tracking-wide dark:text-white/40">
            {d}
          </div>
        ))}
      </div>
      <div className="grid grid-cols-7 gap-2">
        {Array.from({ length: offset }, (_, i) => (
          <div key={`pad-${i}`} />
        ))}
        {Array.from({ length: cells - offset }, (_, i) => (
          <div
            key={i}
            className="aspect-[7/6] rounded-xl bg-terakkiSurfaceAlt border border-terakkiBorder/60 animate-pulse dark:bg-white/10 dark:border-white/10"
            style={{ animationDelay: `${(i % 7) * 40}ms` }}
          />
        ))}
      </div>
    </div>
  );
}
